<div style="width: 100%; height: 60px;">
    <div style="float:right; width: 180px; cursor: pointer;" (click)="onEmail()">
        <img src="../../assets/email.png" alt="Share with email" style="width: 48px; height: auto; vertical-align: middle;">
        <span style="vertical-align: middle;font-weight: bold;margin-left:10px; font-size: 22px;">Email</span>
    </div>
</div>

<pdf-viewer *ngIf="docurl" [src]="docurl"
              [render-text]="false"
              [original-size]="false"
              style="display: block; width: 100%; height: calc(100vh - 100px);"></pdf-viewer>
  <!--
<iframe [src]=docurl width="100%" height="98%" frameborder="0"></iframe>-->
